import useWaitingMutation from '@hooks/useWaitingMutation';
import { prepareDocumentForRetire } from '@common/services/submissionService';
import { ISelectOption, DocumentType } from '@common/types';

export const queryKey = 'retireDocument';

interface IRetireDocumentData {
  documentId: string;
  documentType: DocumentType;
  submissionId: number;
  reason?: ISelectOption;
}

export const usePrepareDocumentForRetire = () => {
  const { mutate } = useWaitingMutation(({ documentId, documentType, submissionId, reason }: IRetireDocumentData) => {
    return prepareDocumentForRetire(submissionId, documentId, documentType, {
      reasonId: reason?.id,
      reason: reason?.value,
    });
  });

  return { prepareDocumentForRetire: mutate };
};
